import useHttp from "../security/Http.hook";
import { SpringMaterial } from "./SpringMaterialApi";

export interface OrderPocketSpring {
  pocketSpring: PocketSpring;
  quantityOrdered: number;
  quantityDelivered?: number;
  unitPrice: number;
}
export interface PocketSpring {
  id?: number;
  name: string;
  width: number;
  zones: PocketSpringZoneModel[];
  price?: number;
}

export interface PocketSpringZoneModel {
  material: SpringMaterial;
  length: number;
}

const useOrderSpringApi = () => {
  const http = useHttp();

  const fetchOrderPocketSprings = async (customerId: number, orderId: number) : Promise<OrderPocketSpring[]> =>
    http.get(`/api/customers/${customerId}/orders/${orderId}/pocket-springs`);

  return {
    fetchOrderPocketSprings
  };
}

export default useOrderSpringApi;